import { Router, ActivatedRoute } from "@angular/router";
import { Component, OnInit, Inject } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { TranslateModule, TranslatePipe } from "@ngx-translate/core";
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
import { UsuarioService } from "../../common/service/usuario.service";
import { CustomAlertService } from "../../common/service/custom-alert.service";
import * as validate from "validate.js";
import { Senha } from "../model/senha";
import { mostrarSenha, impedirEspaco, onKey, isSenhaAceitavel } from "../../common/utils/validacaoSenha";
import { ValidacaoSenhaModel } from "../../common/model/validacao-senha";

@Component({
  selector: "app-alterar-senha",
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    TranslatePipe,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule
  ],
  templateUrl: "./alterar-senha.component.html",
  styleUrls: ["./alterar-senha.component.scss"],
  providers: [
    { useClass: CustomAlertService, provide: CustomAlertService },
    { useClass: UsuarioService, provide: UsuarioService }
  ]
})
export class AlterarSenhaComponent implements OnInit {
  public login: string;
  public email: string;
  public error:any;
  public objAlteracao: Senha;
  public filtro: ValidacaoSenhaModel;
    
  
  constructor(
    private customAlertService: CustomAlertService,
    private usuarioService: UsuarioService,
    private router: Router,
    private route: ActivatedRoute,
    public dialogRef: MatDialogRef<AlterarSenhaComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) 
  {
    this.objAlteracao =new Senha();
    this.login = data.data.login;
    this.objAlteracao.chave = data.chave;
    this.objAlteracao.senha = '';
		this.filtro = new ValidacaoSenhaModel();
  }

  ngOnInit() {
    
  }

  alterarSenha() {    

      this.usuarioService.alterarSenha(this.objAlteracao).subscribe(s=>
        {
          if(s.isValid){
            this.dialogRef.close();
            this.customAlertService.show(
              "Login",
              "login.senhaAlterada",
              "success"
            );
          }
          else{
            if (s.errors.length !== null)
            {
              this.customAlertService.show(
                "telaPadrao.atencao",
                s.errors[0].arguments[0] +"."+ s.errors[0].message,
                "error"
                );
              
            }
            else{
              this.customAlertService.show(
              "telaPadrao.atencao",
              "telaPadrao.alteracaoErro",
              "error"
              );
            }
          }
        }
      );

  }

  validaRegraSenha(event: any): void
	{
		this.filtro.confirmacaoSenha = this.filtro.confirmacaoSenha ?? '';
		this.filtro = onKey(this.filtro, this.objAlteracao.senha, { login: this.login });
	}

	get senhaValida(): boolean {
		return isSenhaAceitavel(this.filtro);
	}

	get mostrarSenha()
	{
		return mostrarSenha;
	}

	get impedirEspaco()
	{
		return impedirEspaco;
	}

}
